import React, {useEffect, useRef, useState} from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { getImage } from "../../contentful/data-provider";
import { BLOCKS } from "@contentful/rich-text-types";

const ThreeColsWithSplitBG = ({content, forFastUsdc = false}) => {

    const [active,setActive] = useState(-1);
    const sliderSection = useRef(null);

    useEffect(()=>{
        if(content.showAsProgress){
            var slideInterval = setInterval(function(){
                if(active < 3){setActive(active+1)}
            },2000)
        }
        if(active === 3){
            clearInterval(slideInterval)
        }
    });

	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => {
				return <p className='text'>{children}</p>;
			},
		},
	};

	const sectionClass = (color, cardBg) => {
		let className = "";

		switch (color) {
			case "gray-left":
				className = "three-cols-with-split-bg-section bg-grey-left";
				break;
			case "gray-right":
				className = "three-cols-with-split-bg-section bg-grey-right";
				break;
			case "yellow-left":
				className = "three-cols-with-split-bg-section bg-yellow-left";
				break;
			case "yellow-right":
				className = "three-cols-with-split-bg-section bg-yellow-right";
				break;
			case "blue-left":
				className = "three-cols-with-split-bg-section bg-blue-left";
				break;
			case "blue-right":
				className = "three-cols-with-split-bg-section bg-blue-right";
				break;
			case "no-bg":
			default:
				className = "three-cols-with-split-bg-section bg-transparent";
				break;
		}

		if (cardBg) {
			return className + " with-card-bg";
		}
		return className;
	};

    const renderTitle = () => {
        if (content.titleImage) {
            return (
                <div className="row section--header">
                    <div className={'col-12 col-md-6'}>
                        <div className={'row align-items-center mb-3 mb-md-0'}>
                            <div className={'col-auto image-col'}>
                                <img src={getImage(content.titleImage).url} alt={getImage(content.titleImage).title}/>
                            </div>
                            <div className={'col-7'}>
                                <h2 className={'mb-0'}>{content.title}</h2>
                            </div>
                        </div>
                    </div>
                    <div className={'col-12 col-md-6 col-lg-5 offset-lg-1'}>
                        {content.body && renderRichText(content.body)}
                    </div>
                </div>
            );
        }
        return (
            <div className="row section--header">
                { !content.hideTitle && <div className={'col-12 col-md-6'}>
                    <div className={'row items-center'}>
                        <div className={'col-10'}>
                            <h2>{content.title}</h2>
                        </div>
                    </div>
                </div>}

				<div className={"col-12 col-md-6 col-lg-5 offset-lg-1"}>{content.body && renderRichText(content.body)}</div>
			</div>
		);
	};

	const renderElementText = (element) => {
		if (element.body) {
			return (
				<>
					<h3>{element.title}</h3>
					{element.body && renderRichText(element.body, options)}
				</>
			);
		}

		return <p>{element.title}</p>;
	};

    if (content.showAsProgress) {
        return (
            <section className="process">
                <div className="container">
                    <div className="row process--header section--header">
                        <div className="col-lg-6">
                            <h2>{content.title}</h2>
                        </div>
                        <div className="col-lg-5 offset-lg-1">
                            {content.body && renderRichText(content.body)}
                        </div>
                    </div>
                    <div ref={sliderSection} className="row process--content">
                        <div className="col-lg-12">
                            <div className="progressbar">
                                <div className="progressbar__bar">
                                    <div className="progressbar__bar--inner">
                                    </div>
                                </div>
                            </div>
                            <div className="step-contents">
                                { content.elements && content.elements.map((element, index) => {
                                    return (
                                        <div className={`step-content ${index <= active && 'active'}`} key={index}>
                                            <div className={`step-num`}>
                                                <p>{index+1}</p>
                                            </div>
                                            <div className="stepcontainer">
                                                <div className="step-content--img">
                                                    <img
                                                        src={getImage(element.image).url}
                                                        alt={getImage(element.image).title}
                                                    />
                                                </div>
                                                <h3>{element.title}</h3>
                                                {element.body && renderRichText(element.body)}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section key={content.id} className={sectionClass(content.backgroundColor, content.colsBackground)}>
            <div className="container">
                <div className="decorate-container">
                    <div className="decorate">
                        <span className="decorate__item"/>
                        <span className="decorate__item"/>
                    </div>
                </div>
                { renderTitle() }
                <div className="row">
                    { content.elements && content.elements.map((element, index) => {
                        return (
                            <div key={index} className="card-element col-12 col-lg-4">
                                <div className="cardbox">
                                    {!forFastUsdc &&
                                        <div className="cardbox--img">
                                            <img src={getImage(element.image).url} alt={getImage(element.image).title}/>
                                        </div>
                                    }
                                    {renderElementText(element)}
                                    {element.ctaUrl &&
                                        <a className="more medium"
                                           href={element.ctaUrl}
                                       target="_self"
                                       rel="noreferrer"
                                    >
                                        <i className="far fa-arrow-right"/>
                                        {element.ctaText}
                                    </a>
                                    }
                                </div>
                            </div>
                        );
                    }) }
                </div>
            </div>
        </section>
    )
}

export default ThreeColsWithSplitBG;
